module.exports = __webpack_public_path__ + "media/src/images/icons/scissors_icon_small-6d9f421677631e4588732682443cffc2.svg";